import breakpoints from './../breakpoints'

export default {
  ...breakpoints,
  medium: {
    ...breakpoints.medium,
    width: 738
  },
  large: {
    ...breakpoints.large,
    width: 960,
    marginOuter: 0
  },
  xlarge: {
    ...breakpoints.xlarge,
    width: 960,
    marginOuter: 0
  }
}
